export const PillDropdown = ({ onChange, placeholder, name, data, value}) => {
    return (
        <div className="pill-input-box">
            <select className="form-select"
                name={name}
                onChange={onChange}
                value={value}
            >
                <option value={null}  defaultValue={null}>{placeholder}</option>
                {data?.map((d, indx) => (
                    <option value={d} key={indx}>{d}</option>
                ))}
            </select>
        </div>
    )
}